/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const updateProfileConfig = {
  showModal: true,
  createModalLabel: 'Edit Organization Info',
  nameLabel: 'Organization Name',
  descriptionLabel: 'Description',
  emailLabel: 'Email Address',
  phoneNumberLabel: 'Contact No.',
  addressLabel: 'Address',
  websiteLabel: 'Website',
  submitButtonText: 'Edit Organization',
  logoLabel: 'Organization Logo',
};
